import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const ProfilePage = () => {
  const { user } = useAuth();

  // Map role to user-friendly display name
  const getRoleName = (role) => {
    const roleMap = {
      'admin': 'Administrator',
      'maker': 'Data Uploader',
      'campaign_manager': 'Campaign Manager',
      'cibil_uploader': 'Cibil Uploader'
    };
    return roleMap[role] || role;
  };
  
  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Header as="h4">User Profile</Card.Header>
            <Card.Body>
              {user ? (
                <div>
                  <div className="mb-3">
                    <strong>Email:</strong> {user.email}
                  </div>
                  <div className="mb-3">
                    <strong>Role:</strong> {getRoleName(user.role)}
                  </div>
                  <div className="mb-3">
                    <strong>User ID:</strong> {user.id}
                  </div>
                  {user.name && (
                    <div className="mb-3">
                      <strong>Name:</strong> {user.name}
                    </div>
                  )}
                </div>
              ) : (
                <p>Loading user information...</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfilePage;